import React, { Component } from 'react';
import Pagination from '@material-ui/lab/Pagination';

class Paginator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      loading: true,
      error: null,
      page: 1,
      pagesCount: 0,
    };
  }

  componentDidMount() {
    this.props.getResource(this.props.params || null);
  }

  componentDidUpdate(prevProps, prevState) {
    const { resource, getResource } = this.props;

    if (resource && resource !== prevProps.resource) {
      this.handleResourceUpdated(resource);
    }

    const { page } = this.state;

    const paramsChanged = JSON.stringify(this.props.params) !== JSON.stringify(prevProps.params);

    if (page !== prevState.page || paramsChanged) {
      const params = { ...this.props.params } || {};

      if(!paramsChanged) {
        params.page = page;
        this.setState({ loading: true });
      } else {
        this.setState({ loading: true, page: 1});
      }
      getResource(params);
    }
  }

  handleResourceUpdated(resource) {
    const {
      data,
      meta,
      reason
    } = resource;
    if (reason) {
      this.setState({
        error: reason,
        loading: false
      });
    } else {
      const pagesCount = meta.last_page > 1 ? meta.last_page : 0;
      const page = meta.current_page;
      this.setState({
        data,
        pagesCount,
        page,
        loading: false
      });
    }
  };

  handleChange = (e, page) => {
    this.setState({ page });
  };

  renderPagination = () => {
    const {
      page,
      pagesCount
    } = this.state;
    if (!pagesCount) return <></>;
    return (
      <Pagination count={pagesCount} page={page} onChange={this.handleChange} />
    );
  };

  render() {
    return this.props.render(
      this.state.data,
      this.renderPagination,
      this.state.loading,
      this.state.error
    );
  }
}

export default Paginator;
